import AlarmsOverviewWidget from "./AlarmsOverviewWidget";

export default AlarmsOverviewWidget